// extracted by mini-css-extract-plugin
module.exports = {"widgetValue":"Analysis_widgetValue__1BW2S","widgetLabel":"Analysis_widgetLabel__15-g2","circle":"Analysis_circle__FN5UB","analysisStats":"Analysis_analysisStats__GN1Mn"};